export const WORKFLOW_TYPES = {
    SCAN_PROCESS: 'SCAN_PROCESS',
    MAIN_PROCESS: 'MAIN_PROCESS'
};
  
export const SCAN_PROCESS_STEPS = {
    PREPARING_SCAN: 'PREPARING_SCAN',
    AXES_ALIGNMENT: 'AXES_ALIGNMENT',
    FINAL_DESIGN_PREVIEW: 'FINAL_DESIGN_PREVIEW'
};
  
export const MAIN_PROCESS_STEPS = {
    RECTIFICATION: 'RECTIFICATION',
    ELONGATION: 'ELONGATION',
    TRIMLINE: 'TRIMLINE',
    FLARES: 'FLARES',
    THICKNESS: 'THICKNESS',
    LOCKING_MECHANISM: 'LOCKING_MECHANISM',
    ALIGNMENT: 'ALIGNMENT',
    VALVE: 'VALVE',
    PADS: 'PADS',
    FINALIZATION: 'FINALIZATION'
};

export const PATHS = {
    [SCAN_PROCESS_STEPS.PREPARING_SCAN]: '/design/scan/preparing',
    [SCAN_PROCESS_STEPS.AXES_ALIGNMENT]: '/design/scan/axes-alignment',
    [SCAN_PROCESS_STEPS.FINAL_DESIGN_PREVIEW]: '/design/scan/final-preview',

    [MAIN_PROCESS_STEPS.RECTIFICATION]:'/design/main/rectification',
    [MAIN_PROCESS_STEPS.ELONGATION]:'/design/main/elongation',
    [MAIN_PROCESS_STEPS.TRIMLINE]:'/design/main/trimline',
    [MAIN_PROCESS_STEPS.FLARES]:'/design/main/flares',
    [MAIN_PROCESS_STEPS.THICKNESS]:'/design/main/thickness',
    [MAIN_PROCESS_STEPS.LOCKING_MECHANISM]:'/design/main/locking-mechanism',
    [MAIN_PROCESS_STEPS.ALIGNMENT]:'/design/main/alignment',
    [MAIN_PROCESS_STEPS.VALVE]:'/design/main/valve',
    [MAIN_PROCESS_STEPS.PADS]:'/design/main/pads',
    [MAIN_PROCESS_STEPS.FINALIZATION]:'/design/main/finalization',
};

export const WORKFLOW_CONFIG ={
    [WORKFLOW_TYPES.SCAN_PROCESS]: {
        steps: Object.values(SCAN_PROCESS_STEPS),
        previousWorkflow: null, // This is the first workflow, so no previous one.
        nextWorkflow: { // Define the transition to the next workflow
            workflow: WORKFLOW_TYPES.MAIN_PROCESS,
            step: MAIN_PROCESS_STEPS.RECTIFICATION,
        }
      },
      [WORKFLOW_TYPES.MAIN_PROCESS]: {
        steps: Object.values(MAIN_PROCESS_STEPS),
        // Define the transition when going back from this workflow's first step.
        previousWorkflow: {
          workflow: WORKFLOW_TYPES.SCAN_PROCESS,
          step: SCAN_PROCESS_STEPS.FINAL_DESIGN_PREVIEW,
        },
        nextWorkflow: null, //This is the last workflow
        // Handle special cases declaratively
        stepHandlers: {
            [MAIN_PROCESS_STEPS.FLARES]: {
            onComplete: (set) => {
                set({ showSocketTypeModal: true });
                // Signal that the default "next step" logic should be skipped
                return { handled: true };
            }
            }
        }
      },
};